export const hexToRgb = (hex: string): { r: number; g: number; b: number } | null => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null
}

export const rgbToHex = (r: number, g: number, b: number): string => {
  return `#${[r, g, b]
    .map((x) => {
      const hex = Math.round(x).toString(16)
      return hex.length === 1 ? `0${hex}` : hex
    })
    .join('')}`
}

export const darkenColor = (hex: string, factor: number = 0.15): string => {
  const rgb = hexToRgb(hex)
  if (!rgb) return hex

  return rgbToHex(
    Math.max(0, rgb.r * (1 - factor)),
    Math.max(0, rgb.g * (1 - factor)),
    Math.max(0, rgb.b * (1 - factor))
  )
}

export const lightenColor = (hex: string, factor: number = 0.25): string => {
  const rgb = hexToRgb(hex)
  if (!rgb) return hex

  return rgbToHex(
    Math.min(255, rgb.r + (255 - rgb.r) * factor),
    Math.min(255, rgb.g + (255 - rgb.g) * factor),
    Math.min(255, rgb.b + (255 - rgb.b) * factor)
  )
}

export const varyColor = (hex: string, variation: number = 0.05): string => {
  const rgb = hexToRgb(hex)
  if (!rgb) return hex

  const shift = Math.sin(variation * Math.PI * 2) * 20
  return rgbToHex(
    Math.max(0, Math.min(255, rgb.r + shift)),
    Math.max(0, Math.min(255, rgb.g + shift * 0.8)),
    Math.max(0, Math.min(255, rgb.b + shift * 1.2))
  )
}
